import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Tooltip from '@mui/material/Tooltip'
import { type LightningReportDataset, lightningReportDatasets } from '@xweather/protect-types'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Box } from '../../../../../components/Box.tsx'
import { I18n } from '../../../../../components/I18n.tsx'
import { useLightningReportTypeRules } from '../../../../../data/analyze/reportTypeRules.ts'
import { ids } from '../../../../../ids.ts'
import { FieldErrorAlert } from '../../fields/FieldErrorAlert.tsx'
import { type LightningReportForm, useLightningFormValues } from '../schema.tsx'

export const DatasetField = () => {
	const { setValue, trigger } = useFormContext<LightningReportForm>()
	const [dataset, geometry] = useLightningFormValues(['dataset', 'geometry'])
	const { coverageZones } = useLightningReportTypeRules()

	// The NLDN dataset is only available inside its boundary, so the dataset must be re-validated when the geometry changes
	// biome-ignore lint/correctness/useExhaustiveDependencies: The validation needs to run when `geometry` changes
	useEffect(() => {
		void trigger('dataset')
	}, [geometry])

	return (
		<>
			<Box>
				<FormLabel required>
					<I18n i18nKey={($) => $.reports.lightning.form.dataset} />
				</FormLabel>
				<RadioGroup
					row
					value={dataset}
					onChange={(_, value) => setValue('dataset', value as LightningReportDataset, { shouldValidate: true })}
					sx={{ flexDirection: 'column' }}
				>
					{lightningReportDatasets.map((dataset) => {
						const isAvailableForSubscription = !!coverageZones[dataset]
						return (
							<Tooltip
								key={dataset}
								title={!isAvailableForSubscription ? <I18n i18nKey={($) => $.reports.featureNotAvailableForSubscription} /> : null}
							>
								<FormControlLabel
									value={dataset}
									disabled={!isAvailableForSubscription}
									control={<Radio data-ta={ids.reports.form.lightning.dataset(dataset)} />}
									label={<I18n i18nKey={($) => $.reports.lightning.form.datasets[dataset]} />}
								/>
							</Tooltip>
						)
					})}
				</RadioGroup>
			</Box>
			<FieldErrorAlert<LightningReportForm> name='dataset' />
		</>
	)
}
